import { produce } from 'immer'
import { SecondaryEmailResponse } from 'src/models/user.models'
import { profileInfoRouteProps } from 'src/navigation/routeProps'
import {
  PATCH_USER_CURRENCY_INIT,
  PATCH_USER_EMPLOYEE_INIT,
  PATCH_USER_FAILURE,
  PATCH_USER_INIT,
  PATCH_USER_LOCALE_INIT,
  PATCH_USER_PROFILE_INIT,
  PATCH_USER_SUCCESS,
  PatchUserActions,
} from 'src/redux/actions/data/users.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface ProfileInfoState {
  patchingUser: boolean
  patchingUserProfile: boolean
  patchingUserLocale: boolean
  patchingUserCurrency: boolean
  patchingUserEmployee: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
  secondaryEmails: SecondaryEmailResponse[]
}

export const initialState: ProfileInfoState = {
  patchingUser: false,
  patchingUserProfile: false,
  patchingUserLocale: false,
  patchingUserCurrency: false,
  patchingUserEmployee: false,
  secondaryEmails: [],
}

export type Actions = PatchUserActions

const CoreProfileInfoReducer = (
  state = initialState,
  action: Actions,
): ProfileInfoState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PATCH_USER_INIT: {
        draft.patchingUser = true
        return draft
      }

      case PATCH_USER_PROFILE_INIT: {
        draft.patchingUser = true
        draft.patchingUserProfile = true
        return draft
      }

      case PATCH_USER_LOCALE_INIT: {
        draft.patchingUser = true
        draft.patchingUserLocale = true
        return draft
      }

      case PATCH_USER_CURRENCY_INIT: {
        draft.patchingUser = true
        draft.patchingUserCurrency = true
        return draft
      }

      case PATCH_USER_EMPLOYEE_INIT: {
        draft.patchingUser = true
        draft.patchingUserEmployee = true
        return draft
      }

      case PATCH_USER_SUCCESS: {
        draft.patchingUser = false
        draft.patchingUserProfile = false
        draft.patchingUserLocale = false
        draft.patchingUserCurrency = false
        draft.patchingUserEmployee = false
        return draft
      }

      case PATCH_USER_FAILURE: {
        draft.patchingUser = false
        draft.patchingUserProfile = false
        draft.patchingUserLocale = false
        draft.patchingUserCurrency = false
        draft.patchingUserEmployee = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const ProfileInfoReducer = createBackgroundReducer(
  profileInfoRouteProps,
  initialState,
  CoreProfileInfoReducer,
)

export default ProfileInfoReducer
